import React from 'react';
import { Button, Link, useTranslate } from 'react-admin';
import { FileEdit, PointOfSale, Ticket } from 'mdi-material-ui';
import { getFirstStockId } from '../../utils/eventSessions';
import { getEventDbId } from '../../utils/eventIdentity';

const EventReports = ({ event, record }) => {
  const translate = useTranslate();
  if (!record?.id) return null;

  const eventDbId = getEventDbId(record || event);
  const isMultiSession =
    record.dateType === 'session' &&
    Array.isArray(record.sessions) &&
    record.sessions.reduce(
      (n, s) => n + (Array.isArray(s?.times) ? s.times.length : s?.times ? 1 : 0),
      0,
    ) >= 2;

  // Multi-session: tüm oturumlar (stockID yok). Tek / oneoff: ilk stock.
  const stockId = isMultiSession ? null : getFirstStockId(record);
  const saleReportPath = stockId
    ? `/sale-report?eventID=${eventDbId}&stockID=${stockId}`
    : `/sale-report?eventID=${eventDbId}`;
  const showSaleReport =
    record.dateType === 'oneoff' || record.dateType === 'session' || Boolean(stockId);

  return (
    <div style={{ marginRight: 15, paddingRight: 15, paddingTop: 10, paddingBottom: 10 }}>
      <h2>{translate('show.sales_reports', 'Sales & Reports')}</h2>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 10,
          alignItems: 'center',
        }}
      >
        {showSaleReport && (
          <Link to={saleReportPath} style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              size="large"
              label={translate('show.sale_report', 'Sale Report')}
            >
              <FileEdit />
              &nbsp;
              <span style={{ fontSize: 12 }}>{translate('show.sale_report', 'Sale Report')}</span>
            </Button>
          </Link>
        )}

        <Link to={`/sales?eventID=${eventDbId}`} style={{ textDecoration: 'none' }}>
          <Button
            variant="outlined"
            size="large"
            label={translate('show.view_all_sales', 'View All Sales')}
          >
            <PointOfSale />
            &nbsp;
            <span style={{ fontSize: 12 }}>
              {translate('show.view_all_sales', 'View All Sales')}
            </span>
          </Button>
        </Link>

        <Link to={`/tickets?eventID=${eventDbId}`} style={{ textDecoration: 'none' }}>
          <Button
            variant="outlined"
            size="large"
            label={translate('show.view_all_tickets', 'View All Tickets')}
          >
            <Ticket />
            &nbsp;
            <span style={{ fontSize: 12 }}>
              {translate('show.view_all_tickets', 'View All Tickets')}
            </span>
          </Button>
        </Link>
      </div>
      <p style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>
        {translate('show.session_filter_hint', {
          _: 'Çok oturumlu etkinliklerde satış / bilet / rapor sayfalarında oturum seçebilirsiniz.',
        })}
      </p>
    </div>
  );
};

export default EventReports;
